const competitions_data = [
  {
    id: "1",
    text: "Since we launched Tezos at the end of 2021, many awesome creators...",
    title: "Coinstore Refer & Win!",
    image: "/images/blog/post_1.jpg",
    date: "5 Feb",
    time: "3 min read",
  },
];

export default competitions_data;
